module.exports = __webpack_public_path__ + "img/horizontal_3_7_8017.9cda3b65.png";